<section id="schedaPartner" class="content-padding darker">
    <div class="narrow-wrapper">
        <form class="has-cols" [formGroup]="operationForm" (ngSubmit)="onSubmit()" *ngIf="operationForm">

            <div class="expert-personal-info">
                <fieldset>
                  <legend>PERSONAL INFORMATION:</legend>
                    <div class="col-48 grid-element" formGroupName="user">
                        <label>Cognome{{ operationForm.get('user').get("surname") | required }}</label>
                        <input type="text" name="surname" formControlName="surname">
                        <app-error-html-handler [ctrl]="operationForm.get('user').get('surname')" [messages]="formValidationMsgs.user.surname"></app-error-html-handler>
                    </div>
        
                    <div class="col-48 grid-element" formGroupName="user">
                        <label>Nome{{ operationForm.get('user').get("name") | required }}</label>
                        <input type="text" name="name" formControlName="name">
                        <app-error-html-handler [ctrl]="operationForm.get('user').get('name')" [messages]="formValidationMsgs.user.name"></app-error-html-handler>
                    </div>
        
                    <div class="col-48 grid-element" formGroupName="user">
                        <label for="emailExpert">E-mail{{ operationForm.get('user').get('email') | required }}</label>
                        <input type="email" name="email" formControlName="email">
                        <app-error-html-handler [ctrl]="operationForm.get('user').get('email')" [messages]="formValidationMsgs.user.email"></app-error-html-handler>
                    </div>
        
                    <div class="col-48 grid-element">
                        <label for="telefonoExpert">Telefono{{ operationForm.get("phone") | required }}</label>
                        <input type="text" name="phone" formControlName="phone">
                        <app-error-html-handler [ctrl]="operationForm.get('phone')" [messages]="formValidationMsgs.phone"></app-error-html-handler>
                    </div>
        
                    <div class="grid-element-full">
                        <label for="indirizzoExpert">
                        Indirizzo{{ operationForm.get("address") | required }}
                        <span class="directions" (click)="directions($event)"><i class="fas fa-directions"></i></span>
                        </label>
                        <app-google-maps-search (setAddress)="getAddress($event)" addressType="geocode" [control]="operationForm.get('address')"></app-google-maps-search>
                        <app-error-html-handler [ctrl]="operationForm.get('address')" [messages]="formValidationMsgs.address"></app-error-html-handler>
                    </div>
                </fieldset>
                <br class="clear">
            </div>

            <div class="expert-personal-info">
                <fieldset>
                    <legend>NOTIFICATIONS:</legend>
                    <div class="col-48 grid-element">
                        <label class="original-label">
                          <input type="checkbox" name="receiveWhatsappMsg" formControlName="receiveWhatsappMsg">
                          Notifiche Whatsapp
                        </label>
                    </div>
          
                    <div class="col-48 grid-element">
                        <label class="original-label">
                          <input type="checkbox" name="receiveEmailMsg" formControlName="receiveEmailMsg">
                          Notifche Mail
                        </label>
                    </div>
                </fieldset>
                <br class="clear">
            </div>

            <div class="team-leader" *ngIf="groups.includes('admin')">
                <fieldset>
                    <legend>PROJECT MANAGER:</legend>
                    <div class="col-48 grid-element">
                        <label class="toggle-container" for="isProjectManager">
                            <input type="checkbox" id="isProjectManager" formControlName="isProjectManager">
                            <span class="toggle-switch"></span>
                            PROJECT MANAGER
                        </label>
                    </div>
                </fieldset>
                <br class="clear">
            </div>

            <div class="expert-personal-info">
                <fieldset>
                    <legend>DOCUMENTAZIONE E NOTE:</legend>
                    <div class="col-48 grid-element">
                        <label for="noteExpert">Note{{ operationForm.get("notes") | required }}</label>
                        <textarea formControlName="notes" rows="5" placeholder="Scrivi una nota"></textarea>
                    </div>
                </fieldset>
                <br class="clear">
            </div>

            <div class="vehicle-and-notes" *ngIf="profile">
                <fieldset>
                    <legend>Password:</legend>
                    <div class="col-48 grid-element" formGroupName="user" *ngIf="profile">
                        <label>Password</label>
                        <input type="password" name="password1" formControlName="password1">
                        <app-error-html-handler [ctrl]="operationForm.get('user').get('password1')" [messages]="formValidationMsgs.user.password1"> </app-error-html-handler>
                    </div>
                    <div class="col-48 grid-element" formGroupName="user" *ngIf="profile">
                        <label>Ripeti password</label>
                        <input type="password" name="password2" formControlName="password2">
                        <app-error-html-handler [ctrl]="operationForm.get('user').get('password2')"[messages]="formValidationMsgs.user.password2"></app-error-html-handler>
                    </div>
                </fieldset>
            </div>

            <div class="center mt-20">
                <button class="btn hvr-shrink center" (click)="$event.preventDefault(); onSubmit()" [disabled]="!operationForm?.valid || tmpBtnDisabled" >
                  Salva<i class="ml-10 far fa-save"></i>
                </button>
            </div>

        </form>
        <br class="clear">
    </div>
</section>